import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { centsToDollars } from '../lib/utils'
export default component((node) => {
  $(node).on('click', async (e) => {
    const price = $(e.target).attr('data-price')
    const value = $(e.target).attr('data-value')
    $('.js-purchase-type').attr('aria-current', false)
    $(e.target).attr('aria-current', true)
    $('.js-product-price').text('$' + centsToDollars(price, true))
    $('.js-pdp-afterpay').attr('data-amount', centsToDollars(price))

    if (value == 'subscription') {
      $('add-button#main-add-to-cart').attr('is-subscription', '')
      $('.dynamic-payment-button').attr('aria-disabled', true) //used for dynamic payment/buy now button
    } else {
      $('add-button#main-add-to-cart').el().removeAttribute('is-subscription')
      $('.dynamic-payment-button').attr('aria-disabled', false) //used for dynamic payment/buy now button
    }
  })
})
